import React from 'react';

// STYLES
import './styles.scss';

export const notFound = (message: string) => (
    <span className="not-found-label">{message}</span>
);
